import { render, staticRenderFns } from "./ProcedureDetailsEdit.vue?vue&type=template&id=87653510&"
import script from "./ProcedureDetailsEdit.vue?vue&type=script&lang=js&"
export * from "./ProcedureDetailsEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProcedureDetailsEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports